import { Routes } from '@angular/router';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { authUserGuard, blockedGuard, guestGuard, newMemberGuard } from './services/auth.service';

export const routes: Routes = [
  {
    title: 'Global Masters',
    path: 'login',
    loadComponent: () => import('./pages/login-page/login-page.component').then(m => m.LoginPageComponent),
  },
  {
    title: 'Global Masters',
    path: 'blocked',
    loadComponent: () => import('./pages/block-page/block-page.component').then(m => m.BlockPageComponent),
  },
  {
    title: 'Sign-in interrupted',
    path: 'oauth-error',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/oauth-error/oauth-error.component').then(m => m.OAuthErrorComponent),
  },
  {
    path: '',
    canActivate: [blockedGuard, authUserGuard, newMemberGuard],
    loadComponent: () => import('./pages/main-page/main-page.component').then(m => m.MainPageComponent),
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        loadChildren: () => import('./routes/home.routes').then(m => m.homeRoutes)
      },
      {
        path: 'welcome',
        loadChildren: () => import('./routes/welcome.routes').then(m => m.welcomeRoutes)
      },
      {
        path: 'challenge/:id/:idCompletion',
        loadChildren: () => import('./routes/challenge-completion.routes').then(m => m.challengeCompletionRoutes)
      },
      {
        path: 'challenge/:id',
        loadChildren: () => import('./routes/challenge.routes').then(m => m.challengeRoutes)
      },
      {
        path: 'levels',
        loadChildren: () => import('./routes/levels.routes').then(m => m.levelsRoutes)
      },
      {
        path: 'leaderboard',
        loadChildren: () => import('./routes/leaderboard.routes').then(m => m.leaderboardRoutes)
      },
      {
        path: 'rewards',
        loadChildren: () => import('./routes/rewards.routes').then(m => m.rewardsRoutes)
      },
      {
        path: 'redeem/:id',
        loadChildren: () => import('./routes/redeem.routes').then(m => m.redeemRoutes)
      },
      {
        path: 'order-success/:id',
        title: 'Your order has been received!',
        loadComponent: () => import('./pages/order-success-page/order-success-page.component').then(m => m.OrderSuccessPageComponent),
      },
      {
        path: 'portal',
        loadChildren: () => import('./routes/portal/portal-shell.routes').then(m => m.portalShellRoutes)
      },
      {
        path: 'admin',
        loadChildren: () => import('./routes/admin/admin-shell.routes').then(m => m.adminShellRoutes)
      },
      { path: '**', component: NotFoundPageComponent, title: '404 - not found' },
    ]
  }
];
